import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import Slider from "./Slider";

export default function AboutSchool() {
  const state = useSelector((state) => state);

  useEffect(() => {}, []);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>
        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/AGIS (3).jpeg") +
              "')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              textAlign: "left",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            About ASPIRE Grove International Pre-School, Devanahalli Premium
            International Pre-School
          </div>
        </div>
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            marginTop: "100px",
          }}
        >
          <h1>Who we are</h1>
          <h3>The right environment for growing</h3>
          Aspire Grove International School is more than just a daycare; it’s a
          place where children lay the groundwork for future success, both
          academically and socially. We understand the demands of today’s
          society, where many mothers are in the workforce, and we provide a
          safe, secure environment where parents can trust that their child is
          in experienced and caring hands. Our AGI welcomes children from as
          young as 1.5 years old up to 6 years of age. We offer flexible
          scheduling options, including 5-day and 6-day programs, ensuring that
          parents have choices that suit their needs.
          <br />
          <br />
        </div>
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            marginTop: "100px",
          }}
        >
          <Grid container spacing={5}>
            <Grid item xs={12} md={5}>
              <img
                style={{ width: "100%", objectFit: "cover", margin: "10px" }}
                src={require("../img/chair.png")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Founder / Chairman's Message
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                A warm welcome to you from the Aspire Grove International
                family. We look forward to enriching our children with a strong
                foundation for their entire educational journey.
                <br />
                <br />
                As the first place where a child experiences time away from
                home, we are committed not only to their joy and safety, but
                also to serving as a bridge between home life and school
                life—gently easing them through this important transition.
                <br />
                <br />
                Furthermore, we believe that parents are our teammates. Your
                involvement in your child’s learning is essential to their
                overall growth and development.
                <br />
                <br />
                Our team of dedicated, passionate, and hardworking educators is
                committed to providing a fun, nurturing, and enriching learning
                experience for our little ones, while keeping parents involved
                every step of the way.
                <br />
                <br />
                <b>Mr. Gopala Gowda M</b> <br />
                Founder Chairman <br />
                Sri Lakshmi Venkateshwara Education Trust <br />
                SLV International School, Vijayapura
                <br />
                <br />
              </div>
            </Grid>
          </Grid>
        </div>
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            marginTop: "100px",
          }}
        >
          <h1>Our Values</h1>
          <h3>Our Approach to Learning</h3>
          We are committed to the vision and values of promoting the holistic
          development of every child. We recognise that all children are unique
          individuals who develop at their own pace. Our practice is underpinned
          by the three characteristics of effective learning—playing and
          exploring, active learning, and creating and thinking critically—which
          support children’s progress across all areas of learning and
          development.
          <br />
          <br />
          We provide a safe, inclusive, and enabling environment where children
          feel secure, valued, and motivated to learn. Our provision is
          carefully planned to meet the individual needs of children across
          different age groups, supporting them to achieve their full potential.
          <br />
          <br />
          Children’s welfare is central to everything we do. We ensure that
          every child is cared for in a warm, nurturing, and responsive manner,
          creating a welcoming and homely environment. We promote positive
          behaviour, mutual respect, and an understanding of fundamental Indian
          values, while encouraging an appreciation of the diverse cultural
          heritage of the community and the wider world.
          <br />
          <br />
          Our aim is to equip children with the confidence, resilience, and key
          skills they need to be well prepared for the next stage of their
          learning and for life beyond the early years.
          <br />
          <br />
        </div>
        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            marginTop: "100px",
          }}
        >
          <div
            style={{
              fontSize: "32px",
              fontFamily: "Montserrat",
              textAlign: "left",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryColor
                  : themeStyle.primaryColor,
              fontWeight: "bold",
            }}
          >
            Our Vision
          </div>
          <br />
          We strive to be a happy, inclusive nursery where children thrive, feel
          confident, and reach their full potential.
          <br />
          <br />
          <div
            style={{
              fontSize: "32px",
              fontFamily: "Montserrat",
              textAlign: "left",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryColor
                  : themeStyle.primaryColor,
              fontWeight: "bold",
            }}
          >
            Our Mission
          </div>
          <br />
          Our mission is to create a nurturing and joyful early learning
          environment where every child feels valued, inspired, and eager to
          learn. We believe that a love for learning begins in the earliest
          years, and when children learn through happiness and curiosity, they
          carry that passion throughout their lives. Through the highest
          standards of childcare and early years education, we provide a strong
          foundation for each child’s future success. We are committed to making
          exceptional early education accessible and affordable, ensuring every
          family has the opportunity to give their child the best possible start
          in life.
          <br />
          <br />
          Contact us for a time filled with laughter and learning.
        </div>
        <Slider />
        {/* <Benchmark /> */}
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
